
import { submit_data, update_data } from "../Api/api";

export const submiterror = (e, allstates, databoj,id) => {


  var [x, y, z] = [allstates["All"], allstates["DailyPost"], allstates["Tech"]];
  // console.log(x, y, z);
  var c = 0;
  if (x || y || z) {
    c = 1;
    console.log("we have one");
  }
  var b = Object.keys(allstates).filter((e) => {
    if (e === "All" || e === "Tech" || e === "DailyPost") {
      return;
    } else {
      if (!allstates[e]) {
        return e;
      }
    }
  });
  // console.log(b);

  return new Promise(async (res, rej) => {
    // var counter1,counter2=0;
    if (c !== 1) {
      // counter2=1;
      return rej("Fill the one type in feild");
      //   console.log("Fill the one type in feild");
    } else if (b.length > 0) {
      //   console.log(`Fill the left Field : ${b} `);
      return rej(`Fill the left Field : ${b} `);
      //   counter1=1;
    } else {
      
      if(Object.keys(databoj).length)
      {
        try {
          var resp = await update_data([allstates,id]);
          console.log(resp.data);
        } catch (err) {
          console.log(err);
        }
      }
      else{
        try {
          var resp = await submit_data(allstates);
          console.log(resp.data);
        } catch (err) {
          console.log(err);
        }
      }
      

      return res("Data has been submitted");
    }
  });
};